import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  RouteComponentProps,
} from "react-router-dom";
import {
  dashboardLayoutRoutes,
  dashboardLayoutCoverRoutes,
  authLayoutRoutes,
  presentationLayoutRoutes,
  // protectedRoutes,
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import DashboardLayoutCover from "../layouts/DashboardCover";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import { RouteType } from "../types/routes";

const childRoutes = (Layout: React.ElementType, routes: Array<RouteType>) =>
  routes.map(
    ({ component: Component, guard, children, path }, index: number) => {
      const Guard = guard || React.Fragment;
      let _routes = [];

      if(Component) {
        _routes.push(<Route
          key={index}
          path={path}
          exact
          render={(props) => (
            <Guard>
              <Layout>
                <Component {...props} />
              </Layout>
            </Guard>
          )}
        />);
      }

      if(children) {
        children.forEach((element, index: number) => {
          const Guard = element.guard || React.Fragment;

          _routes.push(
            <Route
              key={index}
              path={element.path}
              exact
              render={(props: RouteComponentProps) => (
                <Guard>
                  <Layout>
                    <element.component {...props} />
                  </Layout>
                </Guard>
              )}
            />
          );
        })
      }

      return _routes;
    }
  );

const Routes = () => (
  <Router>
    <Switch>
      {childRoutes(DashboardLayout, dashboardLayoutRoutes)}
      {childRoutes(DashboardLayoutCover, dashboardLayoutCoverRoutes)}
      {/* {childRoutes(DashboardLayout, protectedRoutes)} */}
      {childRoutes(AuthLayout, authLayoutRoutes)}
      {childRoutes(AuthLayout, presentationLayoutRoutes)}
      <Route
        render={() => (
          <AuthLayout>
            <Page404 />
          </AuthLayout>
        )}
      />
    </Switch>
  </Router>
);

export default Routes;
